import React from 'react';


const Logout = props => {
    const { appProps, history } = props;

    appProps.handleLogout(history);
    history.push('/signin');

  return (
    <div ></div>
  );
};

export default Logout;
